<template>
	<v-sheet>
		<v-card-title v-if="title" class="d-flex align-center">
			{{ title }}
		</v-card-title>
		<v-card-text>
			<v-form @submit.prevent="search" class="form-inline">
				<v-row>
					<v-col cols="12" class="mt-0 pt-0 d-flex flex-wrap align-center">
						<v-text-field
							class="search-field-name mr-2"
							v-model="query.nickname"
							label="昵称"
							outlined
							dense
							hide-details
							clearable
						></v-text-field>
						<v-text-field
							class="search-field-short mr-2"
							v-model="query.mobile"
							label="手机号"
							outlined
							dense
							hide-details
							clearable
						></v-text-field>
						<v-text-field
							class="mr-2"
							v-model="query.email"
							label="邮箱"
							outlined
							dense
							hide-details
							clearable
						></v-text-field>
						<v-select
							class="mr-2"
							label="状态"
							:items="refs['UserStatus']"
							outlined
							dense
							hide-details
							v-model="query.status"
							clearable
						></v-select>
						<v-btn color="primary" type="submit">搜索</v-btn>
						<v-icon v-if="queryPairs.length > 0" @click="reset">$close</v-icon>
					</v-col>
				</v-row>
			</v-form>

			<v-data-table-server
				:headers="headers"
				:items="objects"
				@update:options="load"
				:items-length="parseInt(total)"
				:loading="loading"
				:show-select="showSelect"
				:single-select="singleSelect"
				v-model="selected"
				multi-sort
			>
				<template v-slot:top>
					<template v-if="selected && selected.length > 0">
						<slot name="batchActions" v-bind:selected="selected"></slot>
					</template>
				</template>
				<template v-slot:item.roles="{ item }">
					<div class="d-flex flex-wrap">
						<v-chip
							v-for="role in item.roles || []"
							:key="role.id"
							size="small"
							variant="tonal"
							class="mr-1 mb-1"
						>
							{{ role.name }}
						</v-chip>
						<span v-if="!(item.roles && item.roles.length)" class="text-medium-emphasis">—</span>
					</div>
				</template>
				<template v-slot:item.action="{ item }">
					<slot name="actions" v-bind:item="item"></slot>
				</template>
				<template v-slot:item.nickname="{ item }">
					<div class="d-flex justify-start align-center">
						<v-img icon :src="item.avatar" style="max-width: 30px; max-height: 30px" />
						{{ item.nickname }}
					</div>
				</template>
				<template v-slot:item.mobile="{ item }">
					<template v-if="item.mobile">
						{{ item.mobile }}
						<!-- <v-icon @click="decodeMobile(item)">mdi-magnify</v-icon> -->
					</template>
				</template>
				<template v-slot:footer>
					<template v-if="selected && selected.length > 0">
						<slot name="batchActions" v-bind:selected="selected"></slot>
					</template>
				</template>
			</v-data-table-server>
		</v-card-text>
	</v-sheet>
</template>

<script>
import { clone, filter, intersection, toPairsIn, valuesIn } from 'lodash-es'

export default {
	components: {},
	props: {
		initQuery: { type: Object, default: null },
		title: { type: String, default: null },
		showSelect: { type: Boolean, default: false },
		singleSelect: { type: Boolean, default: true },
		headers: {
			type: Array,
			default: () => {
				return []
			}
		}
	},
	data() {
		return {
			query: {},
			currentQuery: {}, //当前结果的查询条件
			statuses: [],
			errors: {},
			refs: {},
			objects: [],
			total: 0,
			pageSize: 20,
			loading: false,
			options: {},
			selected: [],
			headers: [
				{ title: '昵称', value: 'nickname' },
				{ title: '手机号', value: 'mobile' },
				{ title: '邮箱', value: 'email' },
				{ title: '状态', value: 'status' },
				{ title: '角色', value: 'roles', sortable: false },
				{ title: '操作', value: 'action' }
			]
		}
	},
	mounted() {
		this.$api.common.meta('user', 'UserStatus,UserType', (r) => (this.refs = r))
		if (this.initQuery) {
			this.query = clone(this.initQuery)
		}
	},
	computed: {
		queryValues() {
			return filter(valuesIn(this.query), (e) => !!e)
		},
		currentQueryValues() {
			return filter(valuesIn(this.currentQuery), (e) => !!e)
		},
		queryPairs() {
			return filter(toPairsIn(this.query), (e) => !!e[1])
		}
	},
	watch: {
		options: {
			handler() {
				this.load()
			},
			deep: true
		}
	},
	methods: {
		search() {
			if (
				this.queryValues.length !== this.currentQueryValues.length ||
				intersection(this.queryValues, this.currentQueryValues).length !== this.queryValues.length
			) {
				//条件变化
				if (this.options.page === 1) {
					//当前如果是第一页，手动触发
					this.load()
				} else {
					this.options.page = 1 //当前不是第一页，修改后通过watcher触发
				}
			} else {
				//条件没变，忽略
			}
		},
		reset() {
			this.query = {}
		},
		load(options = null) {
			if (!this.options) this.options = {}
			if (options) {
				this.options = options
			}

			let { sortBy, page, itemsPerPage } = this.options
			this.loading = true
			let qwp = clone(this.query)
			qwp.pageno = page
			qwp.pagesize = itemsPerPage
			qwp.sortBy = 'id'
			qwp.sortDesc = 'desc'
			if (sortBy && sortBy.length > 0) {
				qwp.sort = sortBy.map((e) => `${e.key} ${e.order}`).join(',')
				qwp.sortBy = sortBy[0]['key']
				qwp.sortDesc = sortBy[0]['order']
			}

			this.currentQuery = clone(this.query)
			this.$api.user.search(
				qwp,
				(response) => {
					this.objects = response.objects
					this.total = response.total
					this.loading = false
				},
				(error) => {
					this.errors = error.message
					this.loading = false
				}
			)
		}
	}
}
</script>

<style scoped></style>
